import React, { useState, useEffect } from 'react';
import numeral from 'numeral';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { get, keyBy, omit, mapValues, } from 'lodash';
import { useDebounce, useToggle, useList, } from 'react-use';
import { toast, } from 'react-toastify';

import firebase from '../../firebase';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import { idWithTenant, } from '../../shared/util';
import useDocumentsFetch from '../hooks/useDocumentsFetch';
import ListForm from '../ListForm';
import PendingItemForm from '../forms/PendingItemForm';
import useCollectionFetch from '../hooks/useCollectionFetch';

const { entries, } = Object;
const db = firebase.firestore();
const inventoriesRef = db.collection('inventories');
const tenantsRef = db.collection('tenants');

export default function ReceivingRequestDetailModal(props) {
  const { isOpen, receivingRequest, onClickClose, } = props;
  const productsRef = receivingRequest.ref.parent.parent.collection('products');
  const products = useDocumentsFetch(receivingRequest.items.map(_ => productsRef.doc(_.productId)), [receivingRequest]);
  const productsById = keyBy(products, 'id');
  const tenantId = receivingRequest.ref.parent.parent.id;

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        入荷依頼詳細
      </ModalHeader>
      <ModalBody>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <th className="table-secondary text-nowrap">入荷依頼ID</th>
              <td>{tenantId}-{receivingRequest.id}</td>
            </tr>
            <tr>
              <th className="table-secondary text-nowrap">伝票番号</th>
              <td>{receivingRequest.documentNumber}</td>
            </tr>
            <tr>
              <th className="table-secondary text-nowrap">商品</th>
              <td>
                {
                  receivingRequest.items.map(({ productId, quantity, }, i) => {
                    return (
                      <div key={i}>
                        {tenantId}-{productId} {numeral(quantity).format()}個
                      </div>
                    );
                  })
                }
              </td>
            </tr>
          </tbody>
        </table>
        <hr className="my-5" />
        <h5>商品</h5>
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th style={{ minWidth: 70 }}>商品ID</th>
              <th style={{ minWidth: 120 }}>商品名</th>
              <th style={{ minWidth: 40 }}>数量</th>
            </tr>
          </thead>
          <tbody>
            {
              receivingRequest.items.map(({ productId, quantity }, i) => {
                const product = productsById[productId];

                return (
                  <tr key={i}>
                    <td>
                      {tenantId}-{productId}
                    </td>
                    <td>
                      {product && product.name}
                    </td>
                    <td className="text-right">
                      {numeral(quantity).format()}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
};
